module.exports = __webpack_public_path__ + "img/IMG_1889-1200w.5b043d6d.jpg";